import {makeStyles} from "@mui/styles";
import {Fragment, useEffect, useState} from "react";
import {Autocomplete, FormControl, FormLabel, Grid, TextField, Typography} from "@mui/material";
import {carManufactures, numArray} from "../../Utils/Helper";

const useStyles = makeStyles({
    smallInput: {
        "& .MuiInputBase-input": {
            height: "0px", // Adjust the height as per your preference
            padding: "2px", // Adjust the padding as per your preference
            fontSize: "14px", // Adjust the font size as per your preference
        }
    }
});

export const WordPressQuoteCarList = ({cbHandleShippingDetails, validatedResult, lng}) => {

    const classes = useStyles();

    const [vehicleDetail, setVehicleDetail] = useState({
            make: null,
            model: null,
            year: null
        }
    );

    const handleInputCarMake = async (event, value) => {
        setVehicleDetail(prevState => ({
            ...prevState,
            make: value
        }));
    }

    const handleChangeCarMake = async (event, value) => {
        setVehicleDetail(prevState => ({
            ...prevState,
            make: value
        }));
    }

    const handleModel = event => {
        const {value} = event.target;
        setVehicleDetail(prevState => ({
            ...prevState,
            model: value
        }))
    }

    const handleYear = (event, value) => {
        setVehicleDetail(prevState => ({
            ...prevState,
            year: value
        }))
    }

    useEffect(() => {
        cbHandleShippingDetails(vehicleDetail);
    }, [vehicleDetail]);

    return (
        <Fragment>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '车的品牌' : "Make"}
                    </FormLabel>
                    <Autocomplete
                        freeSolo
                        value={vehicleDetail?.make}
                        options={carManufactures.filter((option) =>
                            option.toLowerCase().includes(vehicleDetail?.make?.toLowerCase() || "")
                        )}
                        onInputChange={handleInputCarMake}
                        onChange={handleChangeCarMake}
                        renderInput={params => <TextField
                            {...params}
                            variant='outlined'
                            className={classes.smallInput}
                            error={validatedResult !== null && !vehicleDetail?.make}
                            helperText={(validatedResult !== null && !vehicleDetail?.make) && (lng === 'cn' ? "必填" : "Required")}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '车的型号' : "Model"}
                    </FormLabel>
                    <TextField
                        value={vehicleDetail?.model}
                        onInput={handleModel}
                        fullWidth
                        variant='outlined'
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={validatedResult !== null && !vehicleDetail?.model}
                        helperText={(validatedResult !== null && !vehicleDetail?.model) && (lng === 'cn' ? "必填" : "Required")}
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '车的年份' : "Year"}
                    </FormLabel>
                    <Autocomplete
                        value={vehicleDetail?.year}
                        fullWidth
                        options={numArray(1996, new Date().getFullYear() + 1, 'desc')}
                        getOptionLabel={option => option}
                        onChange={handleYear}
                        renderInput={(params) => <TextField
                            variant="outlined"
                            {...params}
                            className={classes.smallInput}
                            error={validatedResult !== null && !vehicleDetail?.year}
                            helperText={(validatedResult !== null && !vehicleDetail?.year) && (lng === 'cn' ? "必填" : "Required")}
                        />}
                        renderOption={(props, option) => (
                            <li {...props}>
                                <Typography style={{fontSize: '12px'}}>
                                    {option}
                                </Typography>
                            </li>
                        )}
                    />
                </FormControl>
            </Grid>
        </Fragment>
    )
}